<template>
  <div class="">
    <div class="">
      <icon 
        :data="icons.ic_comingSoon"
        height="170"
        width="170"
        class="cursor-pointer"
        original
      />
      <div class="font-c8 text-c32 my-3">
        Bientôt disponible
      </div>
      <div class="text-gray2 font-c5 text-c18 w-3/4 mx-auto">
        Nous travaillons actuellement sur une nouvelle mise à jour pour améliorer votre expérience.
      </div>
    </div>
  </div>
</template>

<script>
import ic_comingSoon from "../../../assets/icons/ic_comingSoon.svg"

export default  {
    name: 'CommingSonn',
    data (){
        return{
            icons:{
                ic_comingSoon
            }
        }
    }
}
</script>